import { Singleton } from '@utils/singleton';

@Singleton
export class TranslationService {
  private labels: Record<string, string> = {};

  setLabels(labels: Record<string, string>): void {
    this.labels = labels;
  }

  translate(key: string): string {
    return this.labels[key] ?? key;
  }

  translateArgs(key: string, ...args: string[]): string {
    try {
      return this.replaceArgsInTranslation(this.translate(key), ...args);
    } catch (_err) {
      return key;
    }
  }

  private replaceArgsInTranslation(str: string, ...args: string[]) {
    if (args.length === 0 || !str) {
      return '';
    }
    const mapObj: Record<string, string> = {};
    args.forEach((arg, idx) => (mapObj[`#args${idx + 1}`] = arg));
    const regExp = new RegExp(Object.keys(mapObj).join('|'), 'gi');
    return str.replace(regExp, (matched) => mapObj[matched.toLowerCase()]);
  }
}
